<template>
  <div class="row mb-4 pl-3">
    <template v-if="showEdit">
      <div class="col-sm">
        <validation-provider
          v-slot="{ errors }"
          name="Teléfono"
          rules="required|length:11"
        >
          <custom-input
            v-model="model.locationTelephoneNo"
            custom-error-msg="Campo Requerido"
            :error="errors[0]"
            label="Teléfono:"
            mask-type="Phone"
            placeholder="(___) ___-____"
          />
        </validation-provider>
      </div>

      <div class="col-sm">
        <custom-input
          v-model="model.locationTelephoneFaxNo"
          label="Fax:"
          mask-type="Phone"
          placeholder="(___) ___-____"
        />
      </div>

      <div class="col-sm">
        <custom-input
          v-model="model.locationWebsiteUrl"
          label="Dirección Web:"
          placeholder="www.websitedomain.com"
        />
      </div>
      <div class="col-sm d-flex align-items-end">
        <slot />
      </div>
    </template>

    <template v-else>
      <div class="col-4 my-2">
        <custom-input-display
          v-model="model.locationTelephoneNo"
          label="Teléfono:"
          :mask-type="'Phone'"
          placeholder="(___) ___-____"
        />
      </div>

      <div class="col-4 my-2">
        <custom-input-display
          v-model="model.locationTelephoneFaxNo"
          label="Fax:"
          :mask-type="'Phone'"
          placeholder="(___) ___-____"
        />
      </div>

      <div class="col-4 my-2">
        <custom-input-display
          v-model="model.locationWebsiteUrl"
          label="Dirección Web:"
        />
      </div>
      <div v-if="isMedicaidDocumentationWorkflowEnabled" class="col-4 my-2">
        <custom-input-display
          v-if="showSchoolSection"
          label="NPI LS DEPR:"
          :value="model.locationSchoolNationalIdentifier"
        />
        <validation-provider
          v-else
          ref="npiDeprObserver"
          v-slot="{ errors }"
          rules="required"
        >
          <div
            class="d-flex align-items-center"
            :class="{ 'ml-3': !isNpiDeprDisabled }"
          >
            <custom-input
              v-model="model.locationSchoolNationalIdentifier"
              custom-error-msg="El NPI LS DEPR es requerido."
              :disabled="isNpiDeprDisabled"
              :error="errors[0]"
              label="NPI LS DEPR:"
            />

            <div class="ml-2" :class="{ 'mt-4': !errors?.length }">
              <div v-if="editingNpiDepr">
                <button
                  v-if="canCancelNpiDepr && initialNpiDepr"
                  class="ab-btn ab-btn-outline-danger mt-1 mr-2"
                  type="button"
                  @click="cancelEditNpiDepr"
                >
                  <i class="fas fa-times-circle" />
                </button>

                <button
                  class="ab-btn ab-btn-success mt-1"
                  :disabled="
                    !!errors?.length ||
                      initialNpiDepr == model.locationSchoolNationalIdentifier
                  "
                  type="button"
                  @click="saveNpiDepr"
                >
                  <i class="fas fa-save" />
                </button>
              </div>

              <button
                v-else
                class="ab-btn ab-btn-success mt-1"
                type="button"
                @click="editNpiDepr"
              >
                <i class="fas fa-edit" />
              </button>
            </div>
          </div>
        </validation-provider>
      </div>

      <div v-if="isMedicaidDocumentationWorkflowEnabled" class="col-4 my-2">
        <validation-provider
          ref="npiObserver"
          v-slot="{ errors }"
          rules="required"
        >
          <div
            class="d-flex align-items-center"
            :class="{ 'ml-3': !isNpiDisabled }"
          >
            <custom-input
              v-model="model.nationalIdentifier"
              custom-error-msg="El NPI es requerido."
              :disabled="isNpiDisabled"
              :error="errors[0]"
              label="NPI LS Proveedor:"
            />

            <div class="ml-2" :class="{ 'mt-4': !errors?.length }">
              <div v-if="editingNpi">
                <button
                  v-if="canCancelNpi && initialNpi"
                  class="ab-btn ab-btn-outline-danger mt-1 mr-2"
                  type="button"
                  variant="outline-danger mt-1 mr-2"
                  @click="cancelEditNpi"
                >
                  <i class="fas fa-times-circle" />
                </button>

                <button
                  class="ab-btn ab-btn-success mt-1"
                  :disabled="
                    !!errors?.length || initialNpi == model.nationalIdentifier
                  "
                  type="button"
                  @click="saveNpi"
                >
                  <i class="fas fa-save " />
                </button>
              </div>
              <button
                v-else
                class="ab-btn ab-btn-success mt-1"
                type="button"
                @click="editNpi"
              >
                <i class="fas fa-edit " />
              </button>
            </div>
          </div>
        </validation-provider>
      </div>
    </template>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from '@/components/common/form/CustomInput';
import CustomInputDisplay from '@/components/common/form/CustomInputDisplay';

export default {
  name: 'GeneralInformation',
  components: {
    CustomInput,
    ValidationProvider,
    CustomInputDisplay,
  },
  props: {
    showSchoolSection: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({
        locationTelephoneNo: '',
        locationTelephoneFaxNo: '',
        locationWebsiteUrl: '',
      }),
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    initialNpi: {
      type: String,
      default: '',
    },
    initialNpiDepr: {
      type: String,
      default: '',
    },
    isMedicaidDocumentationWorkflowEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editingNpi: false,
      canCancelNpi: false,
      editingNpiDepr: false,
      canCancelNpiDepr: false,
      model: {
        locationTelephoneNo: '',
        locationTelephoneFaxNo: '',
        locationWebsiteUrl: '',
        nationalIdentifier: '',
        locationSchoolNationalIdentifier: '',
      },
    };
  },
  computed: {
    isNpiDeprDisabled() {
      return !this.editingNpiDepr && !!this.initialNpiDepr;
    },
    isNpiDisabled() {
      return !this.editingNpi && !!this.initialNpi;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal) return;

        const updated = {
          locationTelephoneNo: newVal.locationTelephoneNo || '',
          locationTelephoneFaxNo: newVal.locationTelephoneFaxNo || '',
          locationWebsiteUrl: newVal.locationWebsiteUrl || '',
          nationalIdentifier: newVal.nationalIdentifier || '',
          locationSchoolNationalIdentifier:
            newVal.locationSchoolNationalIdentifier || '',
        };

        if (JSON.stringify(updated) !== JSON.stringify(this.model)) {
          this.model = { ...updated };
        }
      },
    },
    model: {
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        const comparable = {
          locationTelephoneNo: this.value.locationTelephoneNo || '',
          locationTelephoneFaxNo: this.value.locationTelephoneFaxNo || '',
          locationWebsiteUrl: this.value.locationWebsiteUrl || '',
          nationalIdentifier: this.value.nationalIdentifier || '',
          locationSchoolNationalIdentifier:
            this.value.locationSchoolNationalIdentifier || '',
        };

        if (JSON.stringify(newVal) !== JSON.stringify(comparable)) {
          this.$emit('input', { ...this.value, ...newVal });
        }
      },
    },
    initialNpi: {
      immediate: true,
      handler(val) {
        this.editingNpi = !val;
      },
    },
    initialNpiDepr: {
      immediate: true,
      handler(val) {
        this.editingNpiDepr = !val;
      },
    },
  },
  methods: {
    editNpiDepr() {
      this.editingNpiDepr = true;
      this.canCancelNpiDepr = true;
    },
    cancelEditNpiDepr() {
      this.model.locationSchoolNationalIdentifier = this.initialNpiDepr || '';
      this.editingNpiDepr = false;
    },
    async saveNpiDepr() {
      const valid = await this.$refs.npiDeprObserver.validate();
      if (valid) {
        this.$emit(
          'save-npi-depr',
          this.model.locationSchoolNationalIdentifier,
          () => {
            this.editingNpiDepr = false;
          }
        );
      }
    },
    editNpi() {
      this.editingNpi = true;
      this.canCancelNpi = true;
    },
    cancelEditNpi() {
      this.model.nationalIdentifier = this.initialNpi || '';
      this.editingNpi = false;
    },
    async saveNpi() {
      const valid = await this.$refs.npiObserver.validate();
      if (valid) {
        this.$emit('save-npi', this.model.nationalIdentifier, () => {
          this.editingNpi = false;
        });
      }
    },
  },
};
</script>
<style scoped>
::v-deep .input-display > label:first-child {
  font-size: 14px !important;
  color: #727272 !important;
}
</style>
